// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { toast } from 'react-toastify';
import formatDate from '../../utilities/formatDate';
import getSourceIcon from '../../utilities/getSourceIcon';
import copyText from '../../utilities/copy';
import plural from '../../utilities/plural';
import ContextMenu from '../ContextMenu';
import { encodeURL } from '../../utilities/url';




// import '../../styles/trash.css';
import '../../styles/meta.css';
export default class TrashMeta extends React.Component {

    state = {
        showAllMeta: false
    }

    getSelectedDocument = () => {
        if (!this.props.selection || this.props.selection.length !== 1)
            return { _id: null, name: "" };
        const doc = this.props.docs.find(doc => doc._id === this.props.selection[0]);
        // if (!doc)
        //     this.props.select([]);
        return doc;
    }

    getStack = (stackId) => {
        if(!stackId)
            return {_id: null, name: ""}
        
        const stack = this.props.stacks.find(stack => stack._id === stackId);
        return stack; 
    }

    getUserName = (users, userId) => {
        const user = users.find(u => u._id === userId);
        if (!user) return "";
        return user.name;
    }

    getContextMenuOptions = (doc) => {
        let opts = [
            {
                label: 'Copy value',
                action: (meta) => {
                    copyText(meta.value);
                    toast.info("Copied to clipboard");
                }
            },
            {
                label: 'Filter by field',
                action: (meta) => window.location.href = '/field/' + encodeURL(meta.key) + '/' + encodeURL(meta.value)
            }
        ]

        if (this.state.selectedMetaFieldIdx !== null) {
            if (doc.metadata[this.state.selectedMetaFieldIdx]?.confidence < 1 ) {
                opts.push({
                    label: 'Accept value',
                    action: (meta) => {
                        let metadata = [...doc.metadata]
                        // If it has a confidence, set it to 100% 
                        if (metadata[meta.idx].confidence) {
                            metadata[meta.idx].confidence = 1;
                            this.props.updateDocument(doc._id, {
                                metadata
                            });
                        }
                    }
                })
            }
        }
        return opts;
    }

    renderDocFields = (user, team, doc, stack) => {
        return (<>
            <h1>Fields</h1>

            {doc.metadata ? <>
                {(this.state.showAllMeta ? doc.metadata : doc.metadata.slice(0,5)).map((field,idx) => <div
                    className="metadata-field"
                    key={idx}
                >
                    <div
                        className="meta-details-label"
                        title={field.key?.toUpperCase()}
                    >{field.confidence ? (
                        field.confidence < 0.6 ? <div className="meta-details-field-confidence-low" /> :
                        field.confidence < 0.9 ? <div className="meta-details-field-confidence-medium" /> : ""
                    ) : ""} <span className='meta-details-field-key'>{field.key}</span></div>

                    <div
                        className="meta-details-value"
                        title={(field.confidence ? ("[" + (100*field.confidence).toFixed(1) + "%] ") : "") + field.value + (
                            field.pages?.length === 1 ? "\n(page " + String(field.pages[0]+1) + ")" :
                            field.pages?.length > 1 ? "\n(pages " + String(field.pages[0]+1) + " - " + String(field.pages[field.pages.length-1]+1) + ")" : "" 
                        )}
                        onContextMenu={(e) => {
                            this.setState({selectedMetaFieldIdx: idx})
                            this.openCopyMetaMenu(e, {"key": field.key, "value": field.value, "idx": idx})}
                        }
                    >
                        {field.tags?.length > 0 ? <img
                            className="meta-details-tag"
                            src="https://static.stax.ai/images/icons/tag.png"
                            alt="[TAG]"
                        /> : ""}
                        {field.value}
                        
                    </div>
                </div>)
                }

                {doc.metadata.length > 5 && <div
                    className="meta-showmore"
                    onClick={() => this.setState({ showAllMeta: !this.state.showAllMeta })}
                >Show {this.state.showAllMeta ? "fewer": "more"} fields...</div>}

                <ContextMenu
                    load={(open,close) => {
                        this.openCopyMetaMenu = open;
                        this.closeCopyMetaMenu = close;
                    }}
                    options={this.getContextMenuOptions(doc)}
                />
            </> : ""}
        </>);
    }

    render = () => {
        const doc = this.getSelectedDocument(); 
        const stack = this.getStack(doc?.stack);
        const user = this.props.user;
        const team = this.props.team; 
        const uploadedBy = doc?._id && doc?.source === "Uploaded" ? this.getUserName(team.users, doc?.provider) : "";

        return (
            <div className="meta-container">
                    <div
                        className='meta-details'
                    >
                        <h1>Details</h1>

                        {
                            doc?._id? 
                            <>
                                <div className="meta-details-wrapper">
                                    <div className="meta-details-label">File Name</div>
                                    <div className="meta-details-value">{doc?.name}</div>
                                </div>

                                <div className="meta-details-wrapper">
                                    <div className="meta-details-label">Location</div>
                                    <div className="meta-details-value" title={stack?.path??'Unclassified'}><a href={"/stack/" + (doc.stack ? doc.stack : "unclassified")}>{stack?.path??"Unclassified"}</a></div>
                                </div>
                                <div className="meta-details-wrapper">
                                    <div className="meta-details-label"># Pages</div>
                                    <div className="meta-details-value">{doc?.pages?.length??1} {plural('page', doc?.pages?.length??1)} </div>
                                </div>

                                <div className="meta-details-wrapper">
                                    <div className="meta-details-label">Source</div>
                                    <div className="meta-details-value" title={doc.source}>
                                        <img
                                            src={getSourceIcon(doc.source ?? "")}
                                            alt={doc.source}
                                        />
                                        {doc.source && doc.source.includes("Email:") ? <span
                                            style={{
                                                cursor: 'pointer'
                                            }}
                                            title="Click to copy to clipboard."
                                            onClick={() => {
                                                let value = doc.source.split(": ")[1];
                                                if (!value) return;
                                                if (value.includes('<'))
                                                    value = value.split('<')[1];
                                                if (value.includes('>'))
                                                    value = value.split('>')[0];
                                                copyText(value);
                                                toast.info("Copied to clipboard");
                                            }}
                                        >
                                            {doc.source.split(": ")[1]}
                                        </span> : doc.source === "Uploaded" ? <span
                                            title={uploadedBy}
                                        >
                                            {uploadedBy}
                                        </span> : doc.source}
                                    </div>
                                </div>
                                <div className="meta-details-wrapper">
                                    <div className="meta-details-label">Deleted by</div>
                                    <div className="meta-details-value">{this.getUserName(team.users, doc?.deletedBy)}</div>
                                </div>
                                <div className="meta-details-wrapper">
                                    <div className="meta-details-label">Deleted on</div>
                                    <div className="meta-details-value">{formatDate(doc?.deletedOn)}</div>
                                </div>

                                {doc?.metadata?.length > 0? this.renderDocFields(user, team, doc, stack):''}

                            </>:
                            <>
                                <div className="meta-details-wrapper">
                                    <div className="meta-details-label">Total Files</div>
                                    <div className="meta-details-value">{this.props.nDeleted}</div>
                                </div>

                            </>
                           
                        }

                                               
                      
                    </div>
                   
                <div className="meta-details">
                    <div className="meta-details-name">Automatic Garbage Cleanup</div>

                    <div 
                        className='archives-hint'
                    >
                        We keep deleted files here for up to 30 days after they've been deleted.<br /><br />
                        After 30 days these files will be permanently removed from Stax·ai, and all information extracted by the <strong>AI</strong> bots will be lost.
                    </div>

                </div>

            </div>
        );
    }

};